import React, { useEffect, useState } from "react";
import { useTheme } from "../theme/ThemeContext";
import { API_BASE, apiFetch } from "../api";
import ExpenseAnalysis from "../analysis/ExpenseAnalysis";
import { useBudgets } from "../analysis/useBudgets";

// Desktop wrapper around the shared fixed-vs-random spending analysis.
const Analysis = () => {
  const { tokens, fonts } = useTheme();
  const [bills, setBills] = useState(null);
  const [error, setError] = useState(false);
  const budgetsApi = useBudgets();

  useEffect(() => {
    apiFetch(`${API_BASE}/bills`)
      .then((res) => (res.ok ? res.json() : Promise.reject()))
      .then(setBills)
      .catch(() => setError(true));
  }, []);

  return (
    <div style={{ maxWidth: 960 }}>
      <h1 style={{ margin: "4px 0 12px", fontFamily: fonts.display, fontSize: 24, color: tokens.textPrimary }}>Analysis</h1>
      {error && <p style={{ color: tokens.negative, fontSize: 13 }}>Couldn't reach the server. Try again in a moment.</p>}
      {!error && !bills && <p style={{ color: tokens.textMuted, fontSize: 13 }}>Loading…</p>}
      {bills && <ExpenseAnalysis bills={bills} budgets={budgetsApi.budgets} budgetApi={budgetsApi} />}
    </div>
  );
};

export default Analysis;
